import * as React from "react";
import { cn } from "@/design-system/lib/utils";

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, invalid, children, ...props }, ref) => (
    <select
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        "w-full h-10 px-space-3 py-space-2",
        "font-body text-body text-onyx bg-white-pure",
        "border border-border-light rounded-md",
        "focus:outline-none focus:border-gold focus:shadow-goldRing",
        "disabled:bg-white-warm disabled:opacity-60 disabled:cursor-not-allowed",
        invalid && "border-status-error focus:border-status-error",
        className
      )}
      {...props}
    >
      {children}
    </select>
  )
);
Select.displayName = "Select";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid, ...props }, ref) => (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        "w-full px-space-3 py-space-2 min-h-[6rem]",
        "font-body text-body text-onyx bg-white-pure",
        "border border-border-light rounded-md",
        "placeholder:text-gray-mid",
        "focus:outline-none focus:border-gold focus:shadow-goldRing",
        "disabled:bg-white-warm disabled:opacity-60 disabled:cursor-not-allowed",
        invalid && "border-status-error focus:border-status-error",
        className
      )}
      {...props}
    />
  )
);
Textarea.displayName = "Textarea";
